// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__c5wfU","chart_title":"Chart_chart_title__2vyyF","chart_time":"Chart_chart_time__2SgXJ","chart_c":"Chart_chart_c__3Aoxc"};